import dayjs from "dayjs";

export const DEFAULT_GUID = "00000000-0000-0000-0000-000000000000";
const ALL_OPTION_VALUE = "All";

export const getInitialEmployeeProductionDateRange = () => [
    dayjs().startOf("month"),
    dayjs().endOf("month"),
];

const getNormalizedDateRange = (dateRange) => {
    const fallbackRange = getInitialEmployeeProductionDateRange();
    const sourceRange = Array.isArray(dateRange) && dateRange.length === 2
        ? dateRange
        : fallbackRange;
    const normalizedRange = sourceRange.map((date) => dayjs(date));

    if (
        normalizedRange.some((date) => !date.isValid()) ||
        normalizedRange[0].isAfter(normalizedRange[1])
    ) {
        return fallbackRange.map((date) => date.toISOString());
    }

    return normalizedRange.map((date) => date.toISOString());
};

const getSelectedValue = (option, fallbackValue) => {
    if (!option || option.value === ALL_OPTION_VALUE) {
        return fallbackValue;
    }

    return option.value;
};

export const buildInitialSelectedFilters = (filters) =>
    Object.fromEntries(
        Object.entries(filters).map(([key, options]) => [key, options?.[0] ?? null])
    );

export const buildEmployeeProductionFilters = ({
    selectedDateRange,
    selectedFilters = {},
    employeeId,
    status,
    includeInactive = false,
}) => {
    const [startDate, endDate] = getNormalizedDateRange(selectedDateRange);

    const filters = {
        startDate,
        endDate,
        serviceId: getSelectedValue(selectedFilters.services, DEFAULT_GUID),
        employeeId:
            employeeId ?? getSelectedValue(selectedFilters.employees, DEFAULT_GUID),
        departmentId: getSelectedValue(
            selectedFilters.departments,
            DEFAULT_GUID
        ),
        teamId: getSelectedValue(selectedFilters.teams, DEFAULT_GUID),
        includeInactive: Boolean(includeInactive),
    };

    const serviceYear = getSelectedValue(
        selectedFilters.serviceYears,
        ALL_OPTION_VALUE,
    );

    if (serviceYear !== ALL_OPTION_VALUE) {
        filters.serviceYear = serviceYear;
    }

    if (status) {
        filters.status = status;
    }

    return filters;
};

export const buildEmployeeServicesUrl = (filters) => {
    const searchParams = new URLSearchParams({
        startDate: filters.startDate,
        endDate: filters.endDate,
        employeeId: filters.employeeId,
        serviceId: filters.serviceId,
        departmentId: filters.departmentId,
        teamId: filters.teamId,
        includeInactive: String(Boolean(filters.includeInactive)),
    });

    if (filters.serviceYear) {
        searchParams.set("serviceYear", filters.serviceYear);
    }

    if (filters.status) {
        searchParams.set("status", filters.status);
    }

    return `/employeeServices?${searchParams.toString()}`;
};

export const getEmployeeServicesFiltersFromSearchParams = (searchParams) => ({
    startDate: searchParams.get("startDate") || dayjs().toISOString(),
    endDate: searchParams.get("endDate") || dayjs().toISOString(),
    serviceYear: searchParams.get("serviceYear") || ALL_OPTION_VALUE,
    employeeId: searchParams.get("employeeId") || DEFAULT_GUID,
    serviceId: searchParams.get("serviceId") || DEFAULT_GUID,
    departmentId: searchParams.get("departmentId") || DEFAULT_GUID,
    teamId: searchParams.get("teamId") || DEFAULT_GUID,
    status: searchParams.get("status") || ALL_OPTION_VALUE,
    includeInactive: searchParams.get("includeInactive") === "true",
});
